// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2mVsM","disabled":"FileBtn_disabled__jDn-q","warn":"FileBtn_warn__yFBa5","fade":"FileBtn_fade__3XNaB"};